import React from 'react';
import { motion } from 'framer-motion';
import homobLogo from '../assets/images/Hotmob.png'
import './Results.css'

const Results = () => {
  return (
    <div className="voting-page-container">
      <div className="page-header">
        <h2 className="page-subtitle">感謝您的參與﹗</h2>
        <p className="page-subtitle">
          投票結果將會於2027年1 月 15 日頒獎典禮正式公布，並會於翌日上載至 <a className="link" href="https://www.hkaim.org" target="_blank">AIM網站</a>及<a className="link" href="https://www.facebook.com/HKAIM.ORG" target="_blank">社交平台</a>，敬請密切留意 。
        </p>
      </div>
      
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <div>
          <p className="thankyou-description">合作伙伴（公眾投票）<br/>
            <a className="link" href="https://www.hot-mob.com/" target="_blank"><img className="hotmob-logo" alt="Hotmob" src={homobLogo} /></a>
          </p>
          <p className="footer">
            <span>Supported by <a className="link" target="_blank" href="https://www.hot-mob.com/">Hotmob Limited</a></span>
          </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Results;
